import { useSessionStorage, tryOnMounted } from '@vueuse/core'
import { StorageKeys } from '@/constants/storageKey'
import { RwGType, PARTNER_ID_MAP } from '@/constants/rwg'

export function useGoogleAppointment(bid: string | number) {
  const config = useRuntimeConfig()
  const { GOOGLE_APPOINTMENT_OF_CONVERSION_TRACKING_URL } = config.public

  const route = useRoute()
  const bidOfRwG = useSessionStorage<string>(StorageKeys.GOOGLE_APPOINTMENT_BID, '')
  const rwgToken = useSessionStorage<string>(StorageKeys.GOOGLE_APPOINTMENT_TOKEN, '')
  const rwgTokenConsumed = useSessionStorage<boolean>(StorageKeys.GOOGLE_APPOINTMENT_TOKEN_CONSUMED, false)

  const isDifferentBid = computed(() => bidOfRwG.value !== `${bid}`)

  tryOnMounted(() => {
    const newRwgToken = route.query.rwg_token as string

    if (newRwgToken && !rwgTokenConsumed.value) {
      rwgToken.value = newRwgToken
      bidOfRwG.value = `${bid}`
    }
  })

  function sendGoogleAppointment(rwgType: RwGType | null) {
    if (!bidOfRwG.value || !rwgToken.value || rwgType === null) {
      return
    }

    const partnerId = PARTNER_ID_MAP[rwgType]
    if (!partnerId) {
      return
    }

    const payload = {
      conversion_partner_id: partnerId,
      rwg_token: rwgToken.value,
      merchant_changed: isDifferentBid.value ? 1 : 2,
    }

    navigator.sendBeacon(GOOGLE_APPOINTMENT_OF_CONVERSION_TRACKING_URL, JSON.stringify(payload))
    // No matter what the result is, we should delete the token
    deleteGoogleAppointment()
    rwgTokenConsumed.value = true
  }

  function deleteGoogleAppointment() {
    bidOfRwG.value = null
    rwgToken.value = null
  }

  return { rwgToken, sendGoogleAppointment, deleteGoogleAppointment }
}
